import {inject, Injectable} from '@angular/core';
import {Pagination} from "../../../../../../entities/pagination.entity";
import {ChatService} from "../../../../../../services/chat.service";
import {GroupContentItem} from "../../../../../../../../chat-sdk/src/entities/groups/groupContentItem";

@Injectable({
  providedIn: 'root'
})
export class ChatInfoContentMediaService {
  chatService = inject(ChatService);
  groupId = '';
  constructor() {
  }

  getItems(
    page: number = 1,
    filters: any,
    callback: (items: GroupContentItem[], pagination: Pagination) => void
  ) {
    this.chatService.chat.groups.getById(this.groupId).getGroupContent(page, 'media').then(res => {
      if (res) {
        callback(res.items, res.pagination);
      }
    });
  }
}
